
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 502.672 502.672"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M138.29 168.019h258.806v-16.178c0-13.352-10.936-24.267-24.267-24.267H266.011v-14.129c0-20.104-16.351-36.39-36.39-36.39h-62.124c-9.707 0-18.831 3.796-25.734 10.699-6.903 6.903-10.678 15.962-10.678 25.691v14.15H24.267C10.915 127.574 0 138.488 0 151.841v216.722l81.581-165.275c9.901-20.127 34.319-35.269 56.709-35.269zm17.063-54.574c0-3.214 1.316-6.256 3.581-8.542a11.859 11.859 0 018.542-3.602H229.6c6.709 0 12.123 5.436 12.123 12.144v14.15h-86.369v-14.15z"}}),_c('path',{attrs:{"d":"M486.874 192.243H138.29c-13.331 0-29.099 9.793-34.945 21.743L9.599 403.895c-5.91 11.929.194 21.722 13.525 21.722h348.584c13.331 0 29.121-9.772 34.988-21.722l93.725-189.909c5.888-11.95-.173-21.743-13.547-21.743z"}})])
          )
        }
      }
    